/**
 * AnnouncementStatusService
 * Service for managing announcement statuses
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for announcement status CRUD operations
 */
export class AnnouncementStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AnnouncementStatusService.DEFAULT_SERVICE_PATH,
            basePath: AnnouncementStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
AnnouncementStatusService.DEFAULT_SERVICE_PATH = 'announcements';
AnnouncementStatusService.BASE_PATH = 'api/announcement-statuses';
//# sourceMappingURL=AnnouncementStatusService.js.map